module.exports = __webpack_public_path__ + "media/images/dmc/city-tokyo-ba5be91224571fc8135620c1fe83127b.jpg";